<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
          <v-row class="justify-center mt-3">
            <v-col cols="3">
              <v-text-field
                label="Formação"
                v-model="form.filters.formacao"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <sigfoco-date-picker
              :cols="2"
              label="Data de Solicitação"
              v-model="form.filters.dataSolicitacao"
              removeIcon
              outlined
              dense
            ></sigfoco-date-picker>
            <sigfoco-date-picker
              :cols="2"
              label="Data de Realização"
              v-model="form.filters.dataRealizacao"
              removeIcon
              outlined
              dense
            ></sigfoco-date-picker>
            <v-col cols="2">
              <v-autocomplete
                v-model="form.filters.status"
                :items="form.lists.tiposDeStatus"
                label="Status"
                item-text="situacao"
                item-value="id"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
          </v-row>
          <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarFormacao()"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm()"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Incluir"
                icon="mdi-plus"
                :disabled="isOpeningManterFormacao"
                @click="openDialogManterFormacao()"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5"
          :headers="headers"
          :items="form.lists.listFormacoes"
          :items-per-page="10"
          :footer-props="$footerProps"
        >
          <template v-slot:[`item.formacao`]="{ item }">
            {{ item.formacao }}
          </template>
          <template v-slot:[`item.dataSolicitacao`]="{ item }">
            {{ $formatarData(item.dataSolicitacao) }}
          </template>
          <template v-slot:[`item.dataRealizacao`]="{ item }">
            {{ $formatarData(item.dataRealizacao) }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            {{ item.status }}
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
          </template>
          <template v-slot:[`item.acoes`]="{ item }">
            <sigfoco-tooltip
              text="Visualizar"
              icon="mdi-eye-outline"
              small
              @click="openDialogVisualizarFormacao(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              v-if="podeEditarFormacao(item) && !item.reenviarSolicitacao"
              text="Editar"
              icon="mdi-pencil"
              small
              :disabled="isOpeningManterFormacao"
              @click="openDialogManterFormacao(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              v-if="item.statusId == statusFormacaoEnum.CONSOLIDADA && item.qtdReagendamento < 3"
              text="Alterar Data"
              icon="mdi-calendar-edit"
              small
              @click="openDialogReagendarFormacao(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Detalhar Reprovação"
              v-if="item.statusId == statusFormacaoEnum.REPROVADA_APROVACAO || item.statusId == statusFormacaoEnum.REPROVADA_CONSOLIDACAO"
              icon="mdi-eye-circle-outline"
              small
              @click="openDialogJustificativaReprovacao(item, true)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              v-if="!podeEditarFormacao(item)"
              text="Baixar Solicitação de Formação"
              icon="mdi-arrow-down"
              small
              @click="baixarRelatorioPdf(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip v-if="item.reenviarSolicitacao"
              text="Reenviar"
              icon="mdi-replay"
              small
              :disabled="isOpeningManterFormacao"
              @click="openDialogManterFormacao(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Avaliar Formação"
              v-if="item.status == 'Realizada' && item.passouSeteDias"
              icon="mdi-content-duplicate"
              small
              @click="openDialogAvaliacaoFormacao(item)"
            ></sigfoco-tooltip>
          </template>
        </v-data-table>
      </v-container>
      <CadastrarFormacaoDialog
        v-if="dialogManterFormacao.visible"
        :visible="dialogManterFormacao.visible"
        :content="dialogManterFormacao.content"
        :edit="dialogManterFormacao.edit"
        @onClose="fecharDialogManterFormacao"
        @onSave="buscarFormacao()"
      ></CadastrarFormacaoDialog>
      <ReagendarFormacaoDialog 
        v-if="dialogReagendarFormacao.visible"
        :visible="dialogReagendarFormacao.visible"
        :content="dialogReagendarFormacao.content"
        :edit="dialogReagendarFormacao.edit"
        @onClose="dialogReagendarFormacao.close()"
        @onConfirm="buscarFormacao()"
      ></ReagendarFormacaoDialog>
      <JustificativaReprovacaoDialog 
        v-if="dialogJustificativaReprovacao.visible"
        :visible="dialogJustificativaReprovacao.visible"
        :content="dialogJustificativaReprovacao.content"
        :edit="dialogJustificativaReprovacao.edit"
        @onClose="dialogJustificativaReprovacao.close()"
      ></JustificativaReprovacaoDialog>
      <AvaliacaoFormacaoDialog 
        v-if="dialogAvaliarFormacao.visible"
        :visible="dialogAvaliarFormacao.visible"
        :content="dialogAvaliarFormacao.content"
        :edit="dialogAvaliarFormacao.edit"
        @onClose="dialogAvaliarFormacao.close()"
      ></AvaliacaoFormacaoDialog>
    </div>
  </template>
  
  <script>
  import { Formacao } from '~/commons/classes/formacao';
  import { Dialog } from "~/commons/classes/dialog";
  import ManterFormacaoService from '~/services/manter-formacao.service';
  import CadastrarFormacaoDialog from "./dialogs/CadastroFormacao.vue";
  import { globalStore }from "~/mixins/global-formacao.mixin";
  import statusFormacaoEnum from "~/commons/enums/status-formacao.enum";
  import ReagendarFormacaoDialog from "./dialogs/ReagendarFormacao.vue";
  import JustificativaReprovacaoDialog from "./dialogs/JustificativaReprovacao.vue";
  import ManterHistoricoFormacaoService from "~/services/manter-historico-formacao.service";
  import AvaliacaoFormacaoDialog from "./dialogs/AvaliacaoFormacaoDialog.vue";

  export default {
    name: "ManterFormacaoView",
    mixins: [ManterFormacaoService, ManterHistoricoFormacaoService],
    components: {
      CadastrarFormacaoDialog,
      ReagendarFormacaoDialog,
      JustificativaReprovacaoDialog,
      AvaliacaoFormacaoDialog
    },
    data: () => ({
      dialogManterFormacao: Dialog.Build(),
      dialogVisualizarFormacao: Dialog.Build(),
      dialogReagendarFormacao: Dialog.Build(),
      dialogJustificativaReprovacao: Dialog.Build(),
      dialogAvaliarFormacao: Dialog.Build(),
      isOpeningManterFormacao: false,
      form:{
        filters: {
            formacao: null,
            dataSolicitacao: null,
            dataRealizacao: null,
            status: null,
        },
        lists: {
          listFormacoes: [],
          tiposDeStatus: []
        }
      },
      headers: [
        { text: "Formação", align: "center", value: "formacao" },
        { text: "Data de Solicitação", align: "center", value: "dataSolicitacao" },
        { text: "Data de Realização", align: "center", value: "dataRealizacao" },
        { text: "Status", align: "center", value: "status" },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
      ],
      statusFormacaoEnum
    }),
    methods: {
      fecharDialogManterFormacao() {
        this.dialogManterFormacao.close();
        globalStore.limpar();
      },
      buscarFormacao() {
        this.$buscarFormacao({ params: this.form.filters }).then(
          ({ data }) => this.form.lists.listFormacoes = data.lista
        )
      },
      async openDialogManterFormacao(formacao) {
        if (this.isOpeningManterFormacao) return;
        this.isOpeningManterFormacao = true;
        this.showPageLoading();
        globalStore.limpar();

        try {
          if (formacao) {
            globalStore.setFormacaoId(formacao.id);

            // GETs executados sequencialmente para evitar sobrecarga no backend
            const abaPlanoDeTrabalhoResp = await this.$visualizarAbaPlanoDeTrabalho(formacao.id);
            const abaDadosProgramacao = await this.$visualizarAbaProgramacao(formacao.id);

            const dadosPlanoDeTrabalho = abaPlanoDeTrabalhoResp.data.resposta;
            const dadosProgramacao = abaDadosProgramacao.data.lista;

            globalStore.setDadosPlanoDeTrabalho(dadosPlanoDeTrabalho);
            globalStore.setDadosProgramacao(dadosProgramacao);

            globalStore.setReenviarSolicitacao(formacao.reenviarSolicitacao ?? false);
            this.dialogManterFormacao.open(new Formacao(dadosPlanoDeTrabalho), true);
            return;
          }

          globalStore.setViewMode(false);
          globalStore.setReenviarSolicitacao(false);
          this.dialogManterFormacao.open(Formacao.Build());
        } catch (error) {
          console.error('Erro ao abrir formacao:', error);
          this.$notifyError('Não foi possível carregar os dados da formação. Tente novamente.');
        } finally {
          this.isOpeningManterFormacao = false;
          this.hidePageLoading();
        }
      },
      openDialogVisualizarFormacao(formacao) {
        if (formacao) {
            globalStore.limpar();
            globalStore.setFormacaoId(formacao.id);
            globalStore.setViewMode(true);
            this.$nextTick(() => { 
                
                Promise.all([
                    this.$visualizarAbaPlanoDeTrabalho(formacao.id),
                ]).then(([abaPlanoDeTrabalhoResp]) => {
                    const dadosPlanoDeTrabalho = abaPlanoDeTrabalhoResp.data.resposta;
                    globalStore.setDadosPlanoDeTrabalho(dadosPlanoDeTrabalho);

                    this.dialogManterFormacao.open(new Formacao(dadosPlanoDeTrabalho), true, true);
                });
            });
          }
      },
      podeEditarFormacao(formacao) {
        return formacao.statusId == statusFormacaoEnum.NAO_FINALIZADA || formacao.statusId == statusFormacaoEnum.PENDENTE_AJUSTE_APROVACAO || formacao.statusId == statusFormacaoEnum.PENDENTE_AJUSTE_CONSOLIDACAO;
      },
      openDialogAvaliacaoFormacao(historicoFormacao) {
          this.$visualizarQuestionarioParticipante(({ params: {avaliacaoId: historicoFormacao.avaliacaoId, formacaoId: historicoFormacao.id} })).then(
          ({ data }) =>{
             historicoFormacao.questoes = data?.lista;
             this.dialogAvaliarFormacao.open(new Formacao(historicoFormacao))
            }
          );
      },
      openDialogReagendarFormacao(formacao) {
        this.dialogReagendarFormacao.open(formacao);
      },
      openDialogJustificativaReprovacao(formacao, isViewMode = false) {
        this.dialogJustificativaReprovacao.open(formacao, isViewMode);
      },
      openDialogAvaliarFormacao(formacao, isViewMode = false) {
        this.dialogJustificativaReprovacao.open(formacao, isViewMode);
      },
      resetForm() {
        this.form.filters = {
          formacao: null,
          dataSolicitacao: null,
          dataRealizacao: null,
          status: null,
        };
        this.form.lists.listFormacoes = [];
      },
      async baixarRelatorioPdf(formacao) {
        this.showPageLoading();
        try {
          const { data } = await this.$obterRelatorioPDFSolicitacaoFormacao(this.$montarParamsFilters({id: formacao.id}));
          const url = URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "SIGFOCO.RelatórioSolicitacaoFormacao.pdf");
          document.body.appendChild(link);
          link.click();
          this.$notifySuccess("Operação realizada com sucesso.");
          } finally {
          this.hidePageLoading();
        }
      },
      concluirFormacao(item) {
        this.$swal({
          text: `Confirma o reenvio da Solicitação de Formação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          }).then(() => {
              const id = item.id;
              return this.$concluirFormacao(id);
          }).then(({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.$emit("onSave");
            this.$emit('onClose');       
            this.buscarFormacao();      
          });  
      },
    },
    mounted() {
      this.$buscarStatusFormacao().then(({ data }) => {
        this.form.lists.tiposDeStatus = data.lista;
      });
    }
  }
  </script>